<div class="cursor-pointer w-full" (click)="selectMethod($event)">
    <div class="grid grid-cols-3 gap-2">
        <img class="col-span-2 lg:col-span-1 other-payment-options" src="assets/icons/Icons/other-payment-options/payment-ozow_eft.png" alt="ozow eft">
        <div class="col-span-1 lg:col-span-2">
            <div class="w-full align-middle inline-flex justify-center gap-4">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/capitec.png" alt="capitec">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/absa.png" alt="absa">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/tyme-bank-logo.png" alt="tyme bank">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/standard-bank-logo.png" alt="standard bank">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/fnb-logo.png" alt="fnb">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/bank-windhoek-logo.png" alt="bank windhoek">
                <img class="eft-banks invisible lg:visible" src="assets/icons/Icons/eft-banks/bidvest-bank-logo.png" alt="bidvest">
            </div>
        </div>
    </div>
    <div class="grid grid-cols-5 gap-1">
        <p class="col-span-4 subtext mt-2">Pay via EFT using your bank</p>
        <div class="col-span-1">
            <mat-icon class="cursor-pointer float-right" (click)="toggleListView()">info</mat-icon>
        </div>
    </div>
</div>
